import axios from 'axios';
import { SellerHsnCode } from '../types/hsnCode.types';

const BASE = process.env.REACT_APP_API_URL;
const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export interface HsnListResponse {
    hsnCodes: SellerHsnCode[];
    total: number;
    page: number;
    pages: number;
}

export const hsnCodeService = {

    getHsnCodes: (params: Record<string, any>, token: string) =>
        axios.get<HsnListResponse>(`${BASE}/seller/hsn-codes`, { ...auth(token), params }),

    createHsnCode: (data: { hsnCode: string; description: string; gstRate: number }, token: string) =>
        axios.post<{ hsnCode: SellerHsnCode }>(`${BASE}/seller/hsn-codes`, data, auth(token)),

    updateHsnCode: (id: string, data: Partial<{ description: string; gstRate: number; status: string }>, token: string) =>
        axios.put<{ hsnCode: SellerHsnCode }>(`${BASE}/seller/hsn-codes/${id}`, data, auth(token)),

    deleteHsnCode: (id: string, token: string) =>
        axios.delete(`${BASE}/seller/hsn-codes/${id}`, auth(token)),

    toggleStatus: (id: string, status: 'ACTIVE' | 'INACTIVE', token: string) =>
        axios.patch(`${BASE}/seller/hsn-codes/${id}/status`, { status }, auth(token)),
};
